<template>
    <div class="container">
        <case-menu @caseSelect="caseSelect"></case-menu>
        <div>
            <div class="case1">
                <div class="case1Left" data-aos="fade-right">
                    <div>
                        <swiper :options="swiperOption1" ref="mySwiper1" @slideChange="slideChange(1)">
                            <swiper-slide v-for="item,index in hospital1Pic" :key="'hospital1Pic'+index" >
                                <img :src="item" alt="" style="width: 100%;">
                            </swiper-slide>
                        </swiper>
                        <div class="swiperBtn">
                            <i class="el-icon-arrow-left next1"></i>
                            <div>{{ activeIndex1+1 }}/{{hospital1Pic.length}}</div>
                            <i class="el-icon-arrow-right prev1"></i>
                        </div>
                    </div>
                    <div></div>
                </div>
                <div class="case1Right">
                    <div class="title" data-aos="fade-left">{{caseList[0].title}}</div>
                    <div class="border" data-aos="fade-left"></div>
                    <div class="introduction" data-aos="fade-left">{{caseList[0].introduction}}</div>
                    <div class="content" data-aos="fade-left" v-for="item in caseList[0].content">
                        <div>{{item.title}}</div>
                        <div v-html="item.content"></div>
                    </div>
                </div>
            </div>
            <div class="case1">
                <div class="case1Right">
                    <div class="title" data-aos="fade-right">{{caseList[1].title}}</div>
                    <div class="border" data-aos="fade-right"></div>
                    <div class="introduction" data-aos="fade-right">{{caseList[1].introduction}}</div>
                    <div class="content" data-aos="fade-right" v-for="item in caseList[1].content">
                        <div>{{item.title}}</div>
                        <div v-html="item.content"></div>
                    </div>
                </div>
                <div class="case1Left" data-aos="fade-left">
                    <div>
                        <swiper :options="swiperOption2" ref="mySwiper2"  @slideChange="slideChange(2)">
                            <swiper-slide v-for="item,index in hospital2Pic" :key="'hospital1Pic'+index" >
                                <img :src="item" alt="" style="width: 100%;">
                            </swiper-slide>
                        </swiper>
                         <div class="swiperBtn">
                            <i class="el-icon-arrow-left next2"></i>
                            <div>{{activeIndex2+1}}/{{hospital2Pic.length}}</div>
                            <i class="el-icon-arrow-right prev2"></i>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            <div class="case2">
                <div class="case2Left">
                    <img :src="require('@/assets/img/case/case1Left1.png')" alt="" data-aos="zoom-in" width="585">
<!--                    <img :src="require('@/assets/img/case/case1Left2.png')" alt="" data-aos="zoom-in">-->
                    <div data-aos="flip-left"></div>
                    <div data-aos="flip-left" style="top:110px;padding-top:7px"><img :src="require('@/assets/img/case/dfyyLogo.png')" alt=""></div>
<!--                    <div data-aos="flip-left" style="top:540px"><img :src="require('@/assets/img/case/zsdxLogo.png')" alt=""></div>-->
                </div>
                <div class="case2Right">
                    <div v-for="item in case2List">
                        <div class="title" data-aos="fade-up">{{item.title}}</div>
                        <div class="border" data-aos="fade-up"></div>
                        <div class="introduction" data-aos="fade-up">{{item.introduction}}</div>
                        <div class="contentTitle" data-aos="fade-up">{{item.contentTitle}}</div>
                        <div class="content">
                            <div v-for="list in item.content" data-aos="fade-up">{{list}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="distribution">
                <div class="title" data-aos="fade-up">客户分布</div>
                <div class="content">
                    <div class="contentLeft">
                        <div :class="customerActive===0?'customerActive aos-animate':'aos-animate'" data-aos="fade-right" @mouseenter="()=>{this.customerActive = 0}">
                            <div class="number">01</div>
                            <div class="text">华北地区</div>
                            <div class="border"></div>
                            <div class="circle"></div>
                        </div>
                        <div :class="customerActive===1?'customerActive aos-animate':'aos-animate'" data-aos="fade-right" @mouseenter="()=>{this.customerActive = 1}">
                            <div class="number">02</div>
                            <div class="text">华南地区</div>
                            <div class="border"></div>
                            <div class="circle"></div>
                        </div>
                        <div :class="customerActive===2?'customerActive aos-animate':'aos-animate'" data-aos="fade-right" @mouseenter="()=>{this.customerActive = 2}">
                            <div class="number">03</div>
                            <div class="text">华东地区</div>
                            <div class="border"></div>
                            <div class="circle"></div>
                        </div>
                        <div :class="customerActive===3?'customerActive aos-animate':'aos-animate'" data-aos="fade-right" @mouseenter="()=>{this.customerActive = 3}">
                            <div class="number">04</div>
                            <div class="text">华中地区</div>
                            <div class="border"></div>
                            <div class="circle"></div>
                        </div>
                    </div>
                    <div class="phone">
                        <div class="customer">
                           <div v-for="item in customerList[customerActive]" data-aos="flip-down">{{item}}</div>
                        </div>
                        <div class="company">
                            <div class="year" data-aos="flip-down">2026</div>
                            <div class="english" data-aos="flip-down">ETERNAL-HEALTH</div>
                            <div class="name" data-aos="flip-down">上海唐颐</div>
                        </div>
                        <div class="border"></div>
                    </div>
                    <div class="contentRight">
                        <div :class="customerActive===4?'customerActive aos-animate':'aos-animate'" data-aos="fade-left" @mouseenter="()=>{this.customerActive = 4}">
                            <div class="circle"></div>
                            <div class="border"></div>
                            <div class="number">05</div>
                            <div class="text">西北地区</div>
                        </div>
                        <div :class="customerActive===5?'customerActive aos-animate':'aos-animate'" data-aos="fade-left" @mouseenter="()=>{this.customerActive = 5}">
                            <div class="circle"></div>
                            <div class="border"></div>
                            <div class="number">06</div>
                            <div class="text">东北地区</div>
                        </div>
                        <div :class="customerActive===6?'customerActive aos-animate':'aos-animate'" data-aos="fade-left" @mouseenter="()=>{this.customerActive = 6}">
                            <div class="circle"></div>
                            <div class="border"></div>
                            <div class="number">07</div>
                            <div class="text">西南地区</div>
                        </div>
                        <div :class="customerActive===7?'customerActive aos-animate':'aos-animate'" data-aos="fade-left" @mouseenter="()=>{this.customerActive = 7}">
                            <div class="circle"></div>
                            <div class="border"></div>
                            <div class="number">08</div>
                            <div class="text">海南地区</div>
                        </div>
                    </div>
                </div>
                <div><img :src="require('@/assets/img/case/footer.png')" alt="" style="width: 100%;margin-bottom: -4px"></div>
            </div>
        </div>
    </div>
</template>

<script>
import WOW from '../../../node_modules/wowjs/dist/wow';
import CaseMenu from "../../components/CaseMenu";
export default {
	components: {
	    CaseMenu
    },
	data() {
		return {
            caseList: [
                {
                    title:'中国人民解放军总医院——临床生物样本中心样本库',
                    introduction:'项目启动于2012年',
                    content:[
                        {
                            title:'一期',
                            content:'建设临床数据与样本资源库管理系统'
                        },
                        {
                            title:'二期',
                            content:'整合样本数据及海量临床数据'
                        },
                        {
                            title:'三期',
                            content:'大数据整合应用管理'
                        },
                        {
                            title:'四期',
                            content:'整合实验室检测相关工作流程,形成生物样本全流程<br>闭合管理'
                        },
                    ]
                },
                {
                    title:'东方肝胆外科医院——肝癌样本库数据平台',
                    introduction:'项目于 2010 年启动，依托我司样本库信息管理系统，助力东方肝胆外科医院搭建肝癌样本库数据平台，构建大规模临床、病理、基因数据资源库。',
                    content:[
                        {
                            title:'一期',
                            content:'定制开发肝癌样本库信息管理系统'
                        },
                        {
                            title:'二期',
                            content:'集成肝癌样本临床数据，并制定肝癌特色研究基础数据模型'
                        },
                        {
                            title:'三期',
                            content:'依托平台沉淀的数据资源，双方合作产出多篇科研成果论文'
                        }
                    ]
                }
            ],
            case2List:[
                {
                    title:'上海市东方医院干胞临床研究信息管理平台',
                    introduction:'东方医院牵头推动 “国家自主创新示范区干细胞转化医学产业基地” 项目，该项目获上海市批准，落地张江生物医药产业园区。上海唐颐信息技术有限公司承担该项目信息管理平台建设。',
                    contentTitle:'该项目信息管理平台包括以下子系统:',
                    content:[
                        '-- 生物资源样本库建设',
                        '-- 项目管理信息系统建设',
                        '-- 临床资源库建设',
                        '-- 实验室管理信息系统建设',
                        '-- 细胞制备实验室信息管理系统建设',
                        '-- 细胞治疗临床试验信息管理系统建设',
                    ]
                },
                // {
                //     title:'中山大学精准医学科学中心多中心生物样本平台',
                //     introduction:'中山大学精准医学科学中心多中心生物样本平台接入中山大学相关附属机构，如中山大学附属第一医院、中山大学附属第二医院、中山大学附属肿瘤医院及校内各下属单位相关的样本、机构、项目等信息资源，面向多家机构相关生物资源标准化建设，同步接入相应的各家机构自动化的设备信息，进行资源聚合和统一监管，从而形成覆盖多病种、多来源、多模态、多类型的精准数据群，构建起安全、稳定、可操作的精准医学科学中心多中心生物样本平台。\n',
                //     contentTitle:'',
                //     content:[]
                // }
            ],
            customerList:[
                ['中国人民解放军总医院','军事医学科学院','天津医科大学','河北医科大学第一医院','......'],
                ['中山大学精准医学科学中心','南方医科大学南方医院','广东省人民医院','广西医科大学','......'],
                ['上海生物样本库','复旦大学上海医学院','东方肝胆外科医院','复旦大学中山医院','南京鼓楼医院','浙江省儿童医院','......'],
                ['武汉协和医院','湖北医药学院','中南大学肿瘤研究所','......'],
                ['陕西省肿瘤医院','西安市儿童医院','新疆医科大学第一附属医院','甘肃省中医院','......'],
                ['盛京医院','沈阳市精神卫生中心','长春中医药大学附属第三医院','......'],
                ['西南医院','重庆医科大学','贵州医科大学附属医院','昆明儿童医院','大坪医院','......'],
                ['海南省妇女儿童医学中心','......']
            ],
            customerActive:0,
            hospital1Pic:[
                require('@/assets/img/case/hospital1Pic1.png'),
                require('@/assets/img/case/hospital1Pic1.png'),
            ],
            hospital2Pic:[
                require('@/assets/img/case/hospital2Pic1.png'),
                require('@/assets/img/case/hospital2Pic1.png'),
            ],
            swiperOption1:{
              navigation: {
                nextEl: ".prev1",
                prevEl: ".next1",
              },
              slidesPerView: 1,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              direction: "horizontal",
              loop: false,
              centeredSlides: true,
              spaceBetween: 20,
              observer: true,
              observeParents: true,
            },
            swiperOption2:{
              navigation: {
                nextEl: ".prev2",
                prevEl: ".next2",
              },
              slidesPerView: 1,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              direction: "horizontal",
              loop: false,
              centeredSlides: true,
              spaceBetween: 20,
              observer: true,
              observeParents: true,
          },
            activeIndex1:0,
            activeIndex2:0,
        }
	},
	mounted(){
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
	},
    methods:{
        slideChange(ref){
            let key = 'activeIndex'+ref
            let refKey = 'mySwiper'+ref
            this[key] = this.$refs[refKey].swiper.activeIndex
        },
        caseSelect(src){
	        this.$emit('caseSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .case1{
        width: 1054px;
        margin: 144px auto;
        display: flex;
        justify-content: space-between;
        .case1Left{
            width: 521px;
            height: 376px;
            position: relative;
            box-sizing: border-box;
            &>div:nth-child(1){
                position: absolute;
                left: 0;
                top: 0;
                background: #000;
                width: 502px;
                height: 357px;
                .swiperBtn{
                    width: 102px;
                    height: 30px;
                    background: #006efd;
                    padding: 0 10px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    z-index: 9;
                    i{
                        color: #fff;
                        cursor: pointer;
                    }
                    i:hover{
                        color: #ed1c24;
                    }
                    div{
                        color: #fff;
                    }
                }
            }
            &>div:nth-child(2){
                width: 506px;
                height: 364px;
                box-sizing: border-box;
                border: 1px solid #006efd;
                margin: 19px 0 0 15px;
            }
        }
        .case1Right{
            padding-top: 27px;
            padding-right: 30px;
            .title{
                font-size: 19px;
                color: #006efd;
                font-weight: bold;
            }
            .border{
                width: 42px;
                height: 4px;
                margin: 22px 0;
                background: #006efd;
            }
            .introduction{
                font-size: 14px;
                letter-spacing: 1px;
                margin-bottom: 30px;
            }
            .content{
                margin-top: 16px;
                display: flex;
                &>div:nth-child(1){
                    width: 60px;
                    height: 43px;
                    line-height: 43px;
                    background: #f1f1f1;
                    text-align: center;
                    letter-spacing: 1px;
                    margin-right: 26px;
                    font-size: 15px;
                }
                &>div:nth-child(2){
                    font-size: 15px;
                    letter-spacing: 1px;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .case2{
        width: 100%;
        border-bottom: 7px solid #cee7ff;
        display: flex;
        .case2Left{
            width: 50%;
            position: relative;
            text-align: center;
            padding-top: 0px;
            background: #006efd;
            &>img{
                margin-top: 80px;
                /*height: 100%;*/
            }
            &>div:nth-child(3){
                width: 46px;
                height: 46px;
                background: #7eb6ff;
                position: absolute;
                top: 37px;
                right: -23px;
            }
            &>div:nth-child(4),&>div:nth-child(5){
                width: 70px;
                height: 70px;
                padding-top: 5px;
                box-sizing: border-box;
                position: absolute;
                top: 37px;
                right: -35px;
                border-radius: 50%;
                background: #fff;
                text-align: center;
                img{
                    border-radius: 50%;
                }
            }
        }
        .case2Right{
            width: 50%;
            background: #f9f9f9;
            padding-left: 60px;
            box-sizing: border-box;
            &>div{
                margin-top: 120px;
                .title{
                    font-size: 19px;
                    color: #006efd;
                    letter-spacing: 1px;
                }
                .border{
                    width: 41px;
                    height: 3px;
                    background: #006efd;
                    margin: 23px 0 27px 0px;
                }
                .introduction{
                    line-height: 32px;
                    font-size: 15px;
                    width: 500px;
                    margin-bottom: 16px;
                    letter-spacing: 1.1px;
                }
                .contentTitle{
                    font-size: 15px;
                    line-height: 30px;
                }
                .content{
                    width: 620px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    div{
                        width: 50%;
                        line-height: 30px;
                        font-size: 15px;
                        letter-spacing: 2px;
                    }
                }
            }
        }

    }
    .distribution{
        margin-top: 90px;
        width: 100%;
        .title{
            height: 70px;
            font-size: 34px;
            letter-spacing: 10px;
            color: #ed1c24;
            text-align: center;
            background: url("../../assets/img/case/distributionTitle.png") no-repeat center bottom;
        }
        .content{
            width: 1115px;
            display: flex;
            margin: 108px auto 0;
            .contentLeft,.contentRight{
                width: 365px;
                padding-top: 90px;
                box-sizing: border-box;
                z-index: 3;
                &>div{
                    width: 212px;
                    height: 36px;
                    box-sizing: border-box;
                    border: 2px solid #dadada;
                    line-height: 34px;
                    padding-left: 14px;
                    display: flex;
                    position: relative;
                    margin-top: 72px;
                    cursor: pointer;
                    .number{
                        width: 46px;
                        height: 36px;
                        background: #fff;
                        font-size: 34px;
                        margin-top: -2px;
                        text-align: center;
                    }
                    .text{
                        font-size: 19px;
                        letter-spacing: 3px;
                        padding-left: 17px;
                    }
                    .border{
                        position: absolute;
                        right: -189px;
                        top: 16px;
                        width: 178px;
                        height: 1px;
                        border: 1px solid #333;
                        box-sizing: border-box;
                        z-index: 2;
                    }
                    .circle{
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background: #333;
                        position: absolute;
                        right: -205px;
                        top: 8px;
                        z-index: 2;
                    }
                }
            }
            .contentRight{
                padding-left: 150px;
                padding-top: 130px;
                div{
                    .text{
                        color: #033333;
                    }
                    .number{
                        color: #033333;
                    }
                    .circle{
                        left: -205px;
                    }
                    .border{
                        left: -189px;
                    }
                }
            }
             .contentLeft,.contentRight{
                  .customerActive{
                    .text{
                        color: #006efd;
                    }
                    .number{
                        color: #006efd;
                    }
                    .circle{
                        background: #006efd;
                    }
                    .border{
                        border-color: #006efd;
                    }
                }
             }
            .phone{
                width: 385px;
                height: 611px;
                background: url("../../assets/img/case/phone.png") no-repeat center #fff;
                position: relative;
                .customer{
                    height: 366px;
                    padding:  100px 0 0 90px;
                    box-sizing: border-box;
                    div{
                        line-height: 40px;
                        font-size: 17px;
                        color: #006efd;
                        letter-spacing: 1px;
                    }
                }
                .company{
                    padding: 35px 0;
                    .year{
                        text-align: center;
                        font-size: 34px;
                        color: #006efd;
                        letter-spacing: 8px;
                    }
                    .english{
                        margin: 30px 0 35px 0;
                        font-size: 8px;
                        color: #006efd;
                        letter-spacing: 8px;
                        text-align: center;
                        /*font-weight: bold;*/
                    }
                    .name{
                        margin: 0 auto;
                        width: 105px;
                        height: 25px;
                        line-height: 25px;
                        color: #fff;
                        background: #006efd;
                        letter-spacing: 4px;
                        font-size: 16px;
                        text-align: center;
                        border-radius: 5px;
                    }
                }
                .border{
                    width: 217px;
                    height: 11px;
                    position: absolute;
                    bottom: -5px;
                    left: 84px;
                    background: #cee7ff;
                }
            }
        }
    }
</style>
